export default __webpack_public_path__ + "static/eduBannerFiltered-f38d89c301eb484427934282c505aeea.jpg";